import { hosts } from '@/app/config';
import { delay, http, HttpHandler, HttpResponse } from 'msw';

export const featureToggleMocked = http.get(`${hosts.userApi}/feature_toggles/`, async () => {
  await delay(500);

  return HttpResponse.json(featureTogglesResponse);
});

const profileMocked = http.get(`${hosts.userApi}/users/profile/`, async () => {
  return HttpResponse.json(profileResponse);
});

export const featureToggleHandlers: HttpHandler[] = [profileMocked, featureToggleMocked];

const featureTogglesResponse = [
  {
    id: 9001,
    created_at: '2026-08-11T00:00:00.000000Z',
    updated_at: '2026-08-11T00:00:00.000000Z',
    name: 'MAX_AVAILABILITY',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 689,
    created_at: '2022-08-31T18:33:31.817697Z',
    updated_at: '2023-01-05T08:05:06.565497Z',
    name: 'outreach',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 694,
    created_at: '2022-09-12T05:30:17.338133Z',
    updated_at: '2024-03-15T13:35:41.635902Z',
    name: 'search_v2',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 893,
    created_at: '2023-01-10T20:07:46.019939Z',
    updated_at: '2025-07-04T11:58:16.210493Z',
    name: 'ats_pull',
    enabled: true,
    tenant_id: 2512,
    value: 'otys',
  },
  {
    id: 948,
    created_at: '2023-03-06T16:49:17.550385Z',
    updated_at: '2023-03-06T16:49:17.550415Z',
    name: 'indeed-captcha-bypass',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 957,
    created_at: '2023-03-10T12:39:56.747286Z',
    updated_at: '2023-03-10T12:41:57.841128Z',
    name: 'tigris_enabled_oauth2',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 961,
    created_at: '2023-03-10T15:53:40.060364Z',
    updated_at: '2023-03-10T15:53:40.060624Z',
    name: 'search-filters-v2',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 964,
    created_at: '2023-03-14T08:09:20.488117Z',
    updated_at: '2023-03-14T08:09:51.651261Z',
    name: 'search_templates',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 965,
    created_at: '2023-03-14T08:10:35.630170Z',
    updated_at: '2023-03-14T08:10:35.630205Z',
    name: 'search_templates',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 1342,
    created_at: '2023-05-22T10:52:58.555896Z',
    updated_at: '2023-05-22T10:53:38.035007Z',
    name: 'mysolution_enabled_oauth2',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 1556,
    created_at: '2023-06-07T13:46:46.225882Z',
    updated_at: '2023-06-07T13:46:46.225882Z',
    name: 'openai_synonyms',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 2863,
    created_at: '2024-03-11T10:38:03.964797Z',
    updated_at: '2024-03-11T10:38:03.964820Z',
    name: 'dashboard',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 3341,
    created_at: '2024-05-02T11:38:39.189729Z',
    updated_at: '2024-05-02T11:38:39.189729Z',
    name: 'dashboard',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 3616,
    created_at: '2024-06-05T10:55:19.710256Z',
    updated_at: '2024-06-05T10:55:19.710279Z',
    name: 'email_settings',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 4152,
    created_at: '2024-10-31T10:38:06.026505Z',
    updated_at: '2024-10-31T11:26:33.293835Z',
    name: 'connexys_v2_enabled_oauth2',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 4448,
    created_at: '2025-01-02T15:06:01.640361Z',
    updated_at: '2025-01-02T15:06:01.640389Z',
    name: 'ATS_EVENTS_FEATURE_ENABLED',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 4489,
    created_at: '2025-01-22T15:32:14.634934Z',
    updated_at: '2025-10-28T15:39:07.843645Z',
    name: 'robin_resume_otys',
    enabled: false,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 4496,
    created_at: '2025-01-23T14:36:22.147573Z',
    updated_at: '2025-09-01T12:45:55.689283Z',
    name: 'INDEED_MESSAGE_RECEIVED',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 4529,
    created_at: '2025-02-04T10:26:47.452016Z',
    updated_at: '2025-02-04T10:26:47.452046Z',
    name: 'cv_preview_add_suffix',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 4533,
    created_at: '2025-02-05T18:59:52.678256Z',
    updated_at: '2025-02-07T08:10:49.976573Z',
    name: 'JOB_TITLE_SUGGESTIONS_V2',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 4553,
    created_at: '2025-02-17T08:03:15.721654Z',
    updated_at: '2025-11-10T12:37:21.025518Z',
    name: 'FILTER_INDEED_CANDIDATES_BASED_ON_USER_LICENSE',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 4960,
    created_at: '2025-03-03T12:06:53.536564Z',
    updated_at: '2025-03-03T12:06:53.536564Z',
    name: 'JOB_TITLE_SUGGESTIONS_V2',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 5425,
    created_at: '2025-03-13T11:36:34.901970Z',
    updated_at: '2025-10-27T18:53:15.963250Z',
    name: 'robin_resume_carerix',
    enabled: true,
    tenant_id: 2512,
    value: '1',
  },
  {
    id: 5526,
    created_at: '2025-03-26T15:02:07.166357Z',
    updated_at: '2025-05-30T12:08:14.263991Z',
    name: 'AI_REACHOUT_GENERATION',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5531,
    created_at: '2025-03-28T13:56:19.259784Z',
    updated_at: '2025-04-24T10:34:44.798728Z',
    name: 'CENTRAL_INBOX',
    enabled: true,
    tenant_id: 2512,
    value: 'true',
  },
  {
    id: 5570,
    created_at: '2025-04-14T14:54:45.702027Z',
    updated_at: '2025-05-02T07:19:54.063068Z',
    name: 'robin_resume_candidate_statuses',
    enabled: false,
    tenant_id: 2512,
    value: '0',
  },
  {
    id: 5740,
    created_at: '2025-05-24T12:47:27.783673Z',
    updated_at: '2025-05-24T12:47:27.783695Z',
    name: 'CANDIDATE_ORIENTED_DASHBOARD',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5772,
    created_at: '2025-05-30T12:13:36.210810Z',
    updated_at: '2025-10-14T07:10:00.269486Z',
    name: 'SECOND_FOLLOW_UP_IN_MINUTES',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5773,
    created_at: '2025-05-30T12:13:36.211750Z',
    updated_at: '2025-10-14T07:10:00.294881Z',
    name: 'FIRST_FOLLOW_UP_IN_MINUTES',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5791,
    created_at: '2025-06-04T15:19:45.956770Z',
    updated_at: '2025-06-04T15:19:45.956788Z',
    name: 'ATS_JOB_MAP_BY_AI',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5822,
    created_at: '2025-06-18T10:08:00.089834Z',
    updated_at: '2025-10-13T16:56:05.214960Z',
    name: 'ENABLE_VACANCY_CREATION',
    enabled: false,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5844,
    created_at: '2025-06-30T12:14:10.015629Z',
    updated_at: '2025-10-13T16:59:12.910792Z',
    name: 'ENABLE_EMAIL_WITHOUT_NYLAS_CONNECTION',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5895,
    created_at: '2025-07-15T12:36:03.645138Z',
    updated_at: '2025-09-16T14:35:44.937322Z',
    name: 'BEST_MATCH_SEARCH',
    enabled: false,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5930,
    created_at: '2025-07-23T17:25:52.289389Z',
    updated_at: '2025-10-13T17:18:09.266395Z',
    name: 'RJ_COMMUNICATION_HUB',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5932,
    created_at: '2026-05-12T00:00:00.000000Z',
    updated_at: '2026-05-12T00:00:00.000000Z',
    name: 'WA_COMMUNICATION_AGENT',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5982,
    created_at: '2025-08-05T21:58:25.434589Z',
    updated_at: '2025-08-06T03:07:54.421008Z',
    name: 'INDEED_UNLOCK_AI_MESSAGE',
    enabled: false,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5983,
    created_at: '2025-08-05T21:58:25.628478Z',
    updated_at: '2025-08-06T03:09:14.266314Z',
    name: 'WHATSAPP_UNLOCK_AI_MESSAGE',
    enabled: false,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5984,
    created_at: '2025-08-05T21:58:25.643943Z',
    updated_at: '2025-08-06T03:11:18.350793Z',
    name: 'LINKEDIN_IN_MAIL_UNLOCK_AI_MESSAGE',
    enabled: false,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 5985,
    created_at: '2025-08-05T21:58:25.656235Z',
    updated_at: '2025-08-08T17:28:13.848678Z',
    name: 'ALL_UNLOCK_AI_MESSAGE',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 6229,
    created_at: '2025-11-07T14:07:12.946472Z',
    updated_at: '2025-11-07T14:52:41.565378Z',
    name: 'otys_application_status',
    enabled: true,
    tenant_id: 2512,
    value: '2_5102',
  },
  {
    id: 6235,
    created_at: '2025-11-12T13:32:32.217318Z',
    updated_at: '2025-11-12T13:32:32.217344Z',
    name: 'Test_victor',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
  {
    id: 6235,
    created_at: '2025-11-12T13:32:32.217318Z',
    updated_at: '2025-11-12T13:32:32.217344Z',
    name: 'ROBIN_JR_CHAT',
    enabled: true,
    tenant_id: 2512,
    value: null,
  },
];

const profileResponse = {
  id: 16125,
  email: 'gabriel@recruitrobin.com',
  first_name: 'Gabriel',
  last_name: 'G',
  phone_number: null,
  is_staff: true,
  indeed_license: null,
  is_active: true,
  should_change_password: false,
  created_at: '2024-05-17T11:16:51.170804Z',
  updated_at: '2025-11-12T01:21:56.773606Z',
  has_tutorial: true,
  role: 'ADMIN',
  tenant: {
    id: 2512,
    name: 'ROBIN',
    code: 'ROBIN',
    payment_method: 'PAY_PER_MATCH',
    privacy_policy_link: 'www.recruitrobin.com',
  },
  expo_push_token: 'ExponentPushToken[lYciu8I5azV3oUGdyFvL-F]',
  werknl_layout: 'NEW',
  features: [
    {
      name: 'IS_SELECT_HIGH_QUALITY_JOB_MESSAGE_CLOSED',
      value: 'true',
      enabled: true,
      created_at: '2025-08-25T13:16:36.066Z',
      updated_at: '2025-08-25T13:16:36.066Z',
    },
    {
      name: 'ROBIN_JR_FOLLOW_UP',
      value: null,
      enabled: false,
      created_at: '2025-08-25T13:54:27.646Z',
      updated_at: '2025-08-25T13:54:27.646Z',
    },
    {
      name: 'ROBIN_JR_GENERATE_REACHOUT_MESSAGE',
      value: null,
      enabled: true,
      created_at: '2025-05-20T00:01:12.581Z',
      updated_at: '2025-09-19T23:11:04.830Z',
    },
    {
      name: 'SELECTED_LANGUAGE',
      value: 'en',
      enabled: true,
      created_at: '2025-07-23T18:12:17.693Z',
      updated_at: '2025-10-28T21:05:25.375Z',
    },
    {
      name: 'RJ_COMMUNICATION_HUB_DONT_SHOW_GENERATED_MESSAGE',
      value: null,
      enabled: false,
      created_at: '2025-10-27T22:38:50.806Z',
      updated_at: '2025-11-11T13:42:59.329Z',
    },
    {
      name: 'RJ_COMMUNICATION_HUB_DONT_SHOW_WHATSAPP_MESSAGE',
      value: null,
      enabled: false,
      created_at: '2025-10-27T22:38:50.806Z',
      updated_at: '2025-11-11T13:42:59.329Z',
    },
    {
      name: 'RJ_COMMUNICATION_HUB_DONT_SHOW_BULK_EMAIL_PREVIEW',
      value: null,
      enabled: false,
      created_at: '2025-10-27T22:38:50.806Z',
      updated_at: '2025-11-11T13:42:59.329Z',
    },
  ],
};
